module.exports = __webpack_public_path__ + "img/CH01-048-049.159a9474.jpg";